module.exports = __webpack_public_path__ + "static/media/avatar_catapillar.87b6c7b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/avatar_catapillar.png
// module id = 371
// module chunks = 0